import {Route, Routes} from 'react-router-dom'
import Start from '../pages/Start'
import About from '../pages/About'
import EmployerDetails from '../pages/EmployerDetails'
import PrivateRoute from './PrivateRoute'
import EmployeeDetails from '../pages/EmployeeDetails'
import Users from '../pages/Users'
import UserDetails from '../pages/UserDetails'
import Transactions from '../pages/Transactions'
import TransactionDetails from '../pages/TransactionDetails'
import Reconciliations from '../pages/Reconciliations'
import ReconciliationDetails from '../pages/ReconciliationDetails'
import AmlFlaggedCompanyRepresentatives from '../pages/AmlFlaggedCompanyRepresentatives'
import CompanyRepresentativeAmlDetails from '../pages/CompanyRepresentativeAmlDetails'
import Nordea from '../pages/Nordea'
import TaxTables from '../pages/TaxTables'
import Paydays from '../pages/Paydays'
import PaydayDetails from '../pages/PaydayDetails'
import PayRunDetails from '../pages/PayRunDetails'
import PayScheduleDetails from '../pages/PayScheduleDetails'
import Fortnox from '../pages/Fortnox'
import FortnoxActivation from '../pages/FortnoxActivation'
import AmlFlaggedCompanies from '../pages/AmlFlaggedCompanies'
import CompanyAmlDetails from '../pages/CompanyAmlDetails'
import CompanyMonitoring from "../pages/CompanyMonitoring";
import ProtectIssues from '../pages/ProtectIssues'
import ProtectIssueDetails from '../pages/ProtectIssueDetails'
import ProtectRuleDetails from '../pages/ProtectRuleDetails'
import ProtectCustomer from '../pages/ProtectCustomer'
import EmployeePaydayDataDetails from '../pages/EmployeePaydayDataDetails'
import Campaigns from "../pages/Campaigns";
import CampaignDetails from "../pages/CampaignDetails";
import Whistleblower from "../pages/Whistleblower";
import InAppMessages from '../pages/InAppMessages'
import InAppMessageDetails from '../pages/InAppMessageDetails'
import Learning from '../pages/Learning'
import CourseDetails from "../pages/CourseDetails";
import ModuleDetails from "../pages/ModuleDetails";
import LearningAssets from "../pages/LearningAssets";
import Customers from '../pages/Customers'
import CustomerDetails from '../pages/CustomerDetails'
import PayoutCreditFacilityDetails from '../pages/PayoutCreditFacilityDetails'
import CreditFacilityPayoutDetails from '../pages/CreditFacilityPayoutDetails'
import CompanyCheck from "../pages/CompanyCheck";
import PayRunDashboard from "../pages/PayRunDashboard";
import Employees from "../pages/Employees";
import SwishStatus from "../pages/SwishStatus";
import CreditOverview from '../pages/CreditOverview'
import Funding from '../pages/Funding'
import PayrollFileDetails from '../pages/PayrollFileDetails'
import UserCompliance from '../pages/UserCompliance'
import UserComplianceDetails from '../pages/UserComplianceDetails'
import CreditFacilityRepayments from '../pages/CreditFacilityRepayments'

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Start/>}/>
      <Route path="/companymonitor/:marketId/:orgNumber" element={<PrivateRoute><CompanyMonitoring/></PrivateRoute>}/>
      <Route path="/companycheck" element={<PrivateRoute><CompanyCheck/></PrivateRoute>}/>
      <Route path="/customers" element={<PrivateRoute><Customers/></PrivateRoute>}/>
      <Route path="/customers/:id" element={<PrivateRoute><CustomerDetails/></PrivateRoute>}/>
      <Route path="/employers/:employerId/payschedules/:id" element={<PrivateRoute><PayScheduleDetails/></PrivateRoute>}/>
      <Route path="/employers/:id" element={<PrivateRoute><EmployerDetails/></PrivateRoute>}/>
      <Route path="/payoutcreditfacilities/:facilityId/payouts/:payoutId" element={<PrivateRoute><CreditFacilityPayoutDetails/></PrivateRoute>}/>
      <Route path="/payoutcreditfacilities/:id" element={<PrivateRoute><PayoutCreditFacilityDetails/></PrivateRoute>}/>
      <Route path="/users" element={<PrivateRoute><Users/></PrivateRoute>}/>
      <Route path="/users/:id" element={<PrivateRoute><UserDetails/></PrivateRoute>}/>
      <Route path="/paydaydata/:employerId/:paydayId" element={<PrivateRoute><EmployeePaydayDataDetails/></PrivateRoute>}/>
      <Route path="/employees" element={<PrivateRoute><Employees/></PrivateRoute>}/>
      <Route path="/employees/:id" element={<PrivateRoute><EmployeeDetails/></PrivateRoute>}/>
      <Route path="/transactions" element={<PrivateRoute><Transactions/></PrivateRoute>}/>
      <Route path="/transactions/:id" element={<PrivateRoute><TransactionDetails/></PrivateRoute>}/>
      <Route path="/paydays" element={<PrivateRoute><Paydays/></PrivateRoute>}/>
      <Route path="/paydays/:id" element={<PrivateRoute><PaydayDetails/></PrivateRoute>}/>
      <Route path="/paydays/:paydayId/payruns/:id" element={<PrivateRoute><PayRunDetails/></PrivateRoute>}/>
      <Route path="/paydays/:paydayId/payrollfiles/:id" element={<PrivateRoute><PayrollFileDetails/></PrivateRoute>}/>
      <Route path="/learning" element={<PrivateRoute><Learning/></PrivateRoute>}/>
      <Route path="/learning/assets" element={<PrivateRoute><LearningAssets/></PrivateRoute>}/>
      <Route path="/learning/createCourse" element={<PrivateRoute><CourseDetails/></PrivateRoute>}/>
      <Route path="/learning/course/:id" element={<PrivateRoute><CourseDetails/></PrivateRoute>}/>
      <Route path="/learning/course/:courseId/createModule" element={<PrivateRoute><ModuleDetails/></PrivateRoute>}/>
      <Route path="/learning/course/:courseId/module/:id" element={<PrivateRoute><ModuleDetails/></PrivateRoute>}/>
      <Route path="/reconciliations" element={<PrivateRoute><Reconciliations/></PrivateRoute>}/>
      <Route path="/reconciliations/:id" element={<PrivateRoute><ReconciliationDetails/></PrivateRoute>}/>
      <Route path="/protect/issues" element={<PrivateRoute><ProtectIssues/></PrivateRoute>}/>
      <Route path="/protect/issues/:id" element={<PrivateRoute><ProtectIssueDetails/></PrivateRoute>}/>
      <Route path="/protect/rules/:id" element={<PrivateRoute><ProtectRuleDetails/></PrivateRoute>}/>
      <Route path="/protect/customers/:id" element={<PrivateRoute><ProtectCustomer/></PrivateRoute>}/>
      <Route path="/aml/companyRepresentatives" element={<PrivateRoute><AmlFlaggedCompanyRepresentatives/></PrivateRoute>}/>
      <Route path="/aml/companies" element={<PrivateRoute><AmlFlaggedCompanies/></PrivateRoute>}/>
      <Route path="/aml/companies/:id" element={<PrivateRoute><CompanyAmlDetails/></PrivateRoute>}/>
      <Route path="/aml/companyRepresentatives/:id" element={<PrivateRoute><CompanyRepresentativeAmlDetails/></PrivateRoute>}/>
      <Route path="/aml/users" element={<PrivateRoute><UserCompliance/></PrivateRoute>}/>
      <Route path="/aml/users/:id" element={<PrivateRoute><UserComplianceDetails/></PrivateRoute>}/>
      <Route path="/nordea" element={<PrivateRoute><Nordea/></PrivateRoute>}/>
      <Route path="/taxtables" element={<PrivateRoute><TaxTables/></PrivateRoute>}/>
      <Route path="/fortnox" element={<PrivateRoute><Fortnox/></PrivateRoute>}/>
      <Route path="/fortnoxactivation" element={<PrivateRoute><FortnoxActivation/></PrivateRoute>}/>
      <Route path="/campaigns/:id" element={<PrivateRoute><CampaignDetails/></PrivateRoute>}/>
      <Route path="/campaigns" element={<PrivateRoute><Campaigns/></PrivateRoute>}/>
      <Route path="/inappmessages/:id" element={<PrivateRoute><InAppMessageDetails/></PrivateRoute>}/>
      <Route path="/inappmessages" element={<PrivateRoute><InAppMessages/></PrivateRoute>}/>
      <Route path="/whistleblower" element={<PrivateRoute><Whistleblower/></PrivateRoute>}/>
      <Route path="/swishstatus" element={<PrivateRoute><SwishStatus/></PrivateRoute>}/>
      <Route path="/payrun" element={<PrivateRoute><PayRunDashboard/></PrivateRoute>}/>
      <Route path="/creditfacilityrepayments" element={<PrivateRoute><CreditFacilityRepayments/></PrivateRoute>}/>
      <Route path="/credit" element={<PrivateRoute><CreditOverview /></PrivateRoute>}/>
      <Route path="/funding" element={<PrivateRoute><Funding /></PrivateRoute>}/>
      <Route path="/about" element={<About/>}/>
    </Routes>
  )
}

export default Router
